import { ConsoleLogger, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export class UserRoleSynchronizerServiceBase {
    private readonly url = TaggedUrl.join('user/permission/setDefault', [Tags.Api, Tags.OmitMessage]);
    private logger = new ConsoleLogger();

    public constructor(
        private readonly http: HttpService
    ) { }

    public async synchronizeAsync(): Promise<void> {
        try {
            await this.http.post(this.url);
        } catch(err) {
            this.logger.warn(err);
        }
    }
}
